<template>

  <div class="command-center-container" style="">



    <div class="iframe-container">
      <k-tabstrip :selected="selectedTab" @select="onTabSelected" :tab-alignment='alignment' :tabs="AITabs"
                  class="noti-management-tabstrip">
        <template v-slot:UWGuides>
          <aiframe :url="uwGuidesUrl" :azure-id="azureId" :user-name="userName" v-if="selectedTab === 0"></aiframe>

        </template>
        <template v-slot:docsum>
          <aiframe :url="docAnalysisUrl" :azure-id="azureId" :user-name="userName" v-if="selectedTab === 1"></aiframe>
        </template>
        <template v-slot:pipeline>
          <aiframe :url="pipelineUrl" :azure-id="azureId" :user-name="userName" v-if="selectedTab === 2"></aiframe>
        </template>
        <template v-slot:product_finder>
          <aiframe :url="productFinderUrl" :azure-id="azureId" :user-name="userName" v-if="selectedTab === 3"></aiframe>
        </template>
        <template v-slot:genmarket>
          <comingsoon></comingsoon>
        </template>
        <template v-slot:recaloan>
          <comingsoon></comingsoon>
        </template>
        <template v-slot:sumaloan>
          <comingsoon></comingsoon>
        </template>
      </k-tabstrip>

    </div>
    <div class="card-container">
      <div class="totals-container borrower-tasks-totals-container">
        <!-- Header -->
        <div class="column-header">
          <div class="header-icon">
            <i class="fa-duotone fa-solid fa-list-check"></i>
          </div>
          <div class="header-text">
            Borrower Tasks
          </div>
        </div>

        <div class="card-container-flex">
          <!-- MODERN MINIMALIST -->
          <div class="pm-card" ref="btCard">
            <div class="pm-grid">
              <!-- Left: Donut chart -->
              <div class="pm-chart">
                <Chart :donut-center-render="'borrowerCenterRenderer'" @seriesclick="chartClickHandler">
                  <template v-slot:borrowerCenterRenderer>
                    <span class="donut-center-text"><strong>{{ borrowerTaskSum }}</strong></span>
                  </template>

                  <ChartArea :background="'#fff'" :height="donutChartAreaHeight" :width="donutChartAreaWidth" />

                  <ChartSeries>
                    <ChartSeriesItem :type="'donut'" :data-items="borrowerSections" :category-field="'label'"
                                     :field="'value'" :color-field="'color'" :size="donutChartSize" :hole-size="donutChartHoleSize">
                      <!-- Crisp outside labels (reuse your donutLabelContent) -->
                      <ChartSeriesItemLabels :visible="true" :background="'transparent'" :position="'outsideEnd'"
                                             :content="donutLabelContent" />
                    </ChartSeriesItem>
                  </ChartSeries>

                  <ChartLegend :visible="false" />
                </Chart>
              </div>

              <!-- Right: Legend with left badges -->
              <div class="pm-legend">
                <div class="pm-row"
                     @click="showGridDialog(openTaskRequested, openTaskColumns, 'Outstanding Tasks', true)">
                  <span class="pm-badge pm-error">{{ openTaskRequestedTotal }}</span>
                  <span class="pm-label">Outstanding</span>
                </div>

                <div class="pm-row" @click="showGridDialog(openTaskPending, openTaskColumns, 'Pending Tasks', true)">
                  <span class="pm-badge pm-warning">{{ openTaskPendingTotal }}</span>
                  <span class="pm-label">Pending</span>
                </div>

                <div class="pm-row"
                     @click="showGridDialog(openSigningTaskData, openTaskColumns, 'Pending Borrower Signature', true)">
                  <span class="pm-badge pm-success">{{ openSigningTaskTotal }}</span>
                  <span class="pm-label">Pending Signature</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="totals-container">
        <div v-if="!isBranchManager && !isCorp" class="column-header">
          <div class="header-icon">
            <i class="fa-duotone fa-solid fa-list-check"></i>
          </div>
          <div class="header-text">
            Pipeline Management
          </div>
        </div>

        <div v-if="isBranchManager || isCorp" class="column-header">
          <div class="column-header-container">
            <div class="header-icon">
              <i class="fa-duotone fa-solid fa-list-check"></i>
            </div>
            <div class="header-text">
              Pipeline Management
            </div>
          </div>
          <div class="column-header-container">
            <k-switch :onLabel="'All'" :offLabel="'Personal'" :size="'medium'" :checked="pipelineSwitchChecked"
                      @change="onPipelineSwitchChange" />
          </div>
        </div>
        <div class="card-container-flex">

          <!-- MODERN MINIMALIST -->
          <div class="pm-card" ref="pmCard">
            <div class="pm-grid">
              <div class="pm-chart">
                <!-- Left: Donut chart -->
                <div class="chart-col">
                  <!-- Telerik Donut -->
                  <Chart :donut-center-render="'pipelineCenterRenderer'" @seriesclick="chartClickHandler">
                    <template v-slot:pipelineCenterRenderer>
                      <span class="donut-center-text"><strong>{{ pipelineManagementSum }}</strong></span>
                    </template>

                    <ChartArea :background="'#fff'" :height="donutChartAreaHeight" :width="donutChartAreaWidth" />

                    <ChartSeries>
                      <ChartSeriesItem :type="'donut'" :data-items="pipelineManagementSections"
                                       :category-field="'label'" :field="'value'" :color-field="'color'" :size="donutChartSize"
                                       :hole-size="donutChartHoleSize">
                        <!-- Better looking labels -->
                        <ChartSeriesItemLabels :visible="true" :background="'transparent'" :position="'outsideEnd'"
                                               :content="donutLabelContent" />
                      </ChartSeriesItem>
                    </ChartSeries>

                    <ChartLegend :visible="false" />
                  </Chart>
                </div>

              </div>

              <div class="pm-legend">
                <div class="pm-row" @click="showDisclosures">
                  <span class="pm-badge pm-info">{{ disclosuresTotal }}</span>
                  <span class="pm-label">Pending LO Signature</span>
                </div>
                <div class="pm-row" @click="showGridDialog(newAppsData, newAppsColumns, 'New Applications')">
                  <span class="pm-badge pm-primary">{{ newAppsTotal }}</span>
                  <span class="pm-label">New Applications</span>
                </div>
                <div class="pm-row"
                     @click="showGridDialog(incompleteAppsData, incompleteAppsColumns, 'Incomplete Applications', false, true)">
                  <span class="pm-badge pm-warning">{{ incompleteAppsTotal }}</span>
                  <span class="pm-label">Incomplete Applications</span>
                </div>
                <div class="pm-row" @click="showGridDialog(expiringLocksData, expiringLocksColumns, 'Expiring Locks')">
                  <span class="pm-badge pm-error">{{ expiringLocksTotal }}</span>
                  <span class="pm-label">Expiring Locks</span>
                </div>
                <div class="pm-row" @click="showGridDialog(unlockedLoansData, unlockedLoansColumns, 'Unlocked Loans')">
                  <span class="pm-badge pm-success">{{ unlockedLoansTotal }}</span>
                  <span class="pm-label">Unlocked Loans</span>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
      <div class="totals-container">
        <div class="column-header">
          <div class="column-header-container">
            <div class="header-icon">
              <i class="fa-duotone fa-solid fa-list-check"></i>
            </div>
            <div class="header-text">Loan Tasks</div>
          </div>
          <div class="column-header-container">
            <k-switch v-if="isGrouped" :onLabel="'All'" :offLabel="'Personal'" :size="'medium'" :checked="taskSwitchChecked"
                      @change="onTaskSwitchChange" />
          </div>
        </div>

        <div class="card-container-flex">
          <!-- MODERN MINIMALIST -->
          <div class="pm-card" ref="ltCard">
            <div class="pm-grid">
              <!-- Left: Donut chart -->
              <div class="pm-chart">
                <Chart :donut-center-render="'internalCenterRenderer'" @seriesclick="chartClickHandler">
                  <template v-slot:internalCenterRenderer>
                    <span class="donut-center-text"><strong>{{ internalTaskSum }}</strong></span>
                  </template>

                  <ChartArea :background="'#fff'" :height="donutChartAreaHeight" :width="donutChartAreaWidth" />

                  <ChartSeries>
                    <ChartSeriesItem :type="'donut'" :data-items="internalSections" :category-field="'label'"
                                     :field="'value'" :color-field="'color'" :size="donutChartSize" :hole-size="donutChartHoleSize">
                      <ChartSeriesItemLabels :visible="true" :background="'transparent'" :position="'outsideEnd'"
                                             :content="donutLabelContent" />
                    </ChartSeriesItem>
                  </ChartSeries>

                  <ChartLegend :visible="false" />
                </Chart>
              </div>

              <!-- Right: Legend with left badges -->
              <div class="pm-legend">
                <div class="pm-row"
                     @click="showGridDialog(internalTaskRequested, internalTaskColumns, 'Outstanding Loan Tasks')">
                  <span class="pm-badge pm-error">{{ internalTaskRequestedTotal }}</span>
                  <span class="pm-label">Outstanding</span>
                </div>

                <div class="pm-row"
                     @click="showGridDialog(internalTaskPending, internalTaskColumns, 'Open Loan Tasks')">
                  <span class="pm-badge pm-warning">{{ internalTaskPendingTotal }}</span>
                  <span class="pm-label">Open</span>
                </div>

                <div class="pm-row" @click="showGridDialog(followUpToday, internalTaskColumns, 'Due Today')">
                  <span class="pm-badge pm-primary">{{ followUpTodayTotal }}</span>
                  <span class="pm-label">Due Today</span>
                </div>

                <div class="pm-row" @click="showGridDialog(pastDue, internalTaskColumns, 'Past Due')">
                  <span class="pm-badge pm-critical">{{ pastDueTotal }}</span>
                  <span class="pm-label">Past Due</span>
                </div>

                <div class="pm-row" @click="showGridDialog(tasksIAssigned, internalTaskColumns, 'Tasks I Assigned')">
                  <span class="pm-badge pm-purple">{{ tasksIAssignedTotal }}</span>
                  <span class="pm-label">Tasks I Assigned</span>
                </div>

                <div class="pm-row" @click="showGridDialog(teamTasks, internalTaskColumns, 'Team Tasks')">
                  <span class="pm-badge pm-teal">{{ teamTasksTotal }}</span>
                  <span class="pm-label">Team Tasks</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!---->
    </div>


    <div class="notification-container">
      <k-dialog v-if="notificationDialog" :title="'Notification'"
                @close="(() => notificationDialog = !notificationDialog)"
                @overlay-click="(() => notificationDialog = !notificationDialog)">
        <div class="html-cont" v-html="this.dialogData.message">
        </div>
      </k-dialog>

    </div>
    <k-dialog v-if="gridDialog" :title="pipelineTitle" @close="onGridDialogClose">
      <kbutton v-if="sendNotiButton" @click="onSendTaskNotification">
        <i class="fa-duotone fa-solid fa-envelope"></i> Send Task Notifications
      </kbutton>

      <div class="dialog-grid-container">
        <Grid :filterable="true" :filter="filter" @filterchange="filterChange" :cell-render="pipelineCell"
              :selectable="{ mode: 'multiple' }" :selected-field="selectedField" @selectionChange="onSelectionChange"
              @headerselectionchange="onHeaderSelectionChange" :sortable="true" :sort="sort" @sortchange="sortChangeHandler"
              :style="{ height: '100%' }" :data-items="result" :columns="gridDialogColumns" @rowclick="navigateToLoan">
          <!-- Grid Toolbar -->
          <GridToolbar>
            <div class="toolbar-container">
              <!-- Search Input -->
              <k-input class="search-input" placeholder="Search in all columns..." v-model="searchWord"
                       @input="onFilter"></k-input>
              <div>
                <!-- Export Button -->
                <k-switch v-if="incompleteAppSwitch" :onLabel="'All'" :offLabel="'Personal'" :size="'medium'"
                          :checked="incompleteAppSwitchChecked" @change="onIncompleteAppSwitchChange" />
                <kbutton class="exportExcelButton" :theme-color="'primary'" @click="exportExcel">
                  Export Excel
                </kbutton>

              </div>
            </div>
          </GridToolbar>
          <template v-slot:pipelineCell="{ props }">
            <td class="pipeline-cell">{{ getNestedValue(props.field, props.dataItem) }}</td>
          </template>
          <template v-slot:checkBox="{ props }">
            <td class="pipeline-cell">
              <checkbox :checked="props.dataItem.selected" @change="onSelectionChange(props.dataItem)" />
            </td>
          </template>
          <template v-slot:dateCell="{ props }">
            <td class="pipeline-cell">
              {{ formatDate(props) }}
            </td>
          </template>
          <template v-slot:assignedToCell="{ props }">
            <td class="pipeline-cell">
              <span v-if="props.dataItem.assignedto && props.dataItem.assignedto.trim() !== ''">
                {{ props.dataItem.assignedto }}
              </span>
              <span v-else-if="props.dataItem.teamids && props.dataItem.teamids !== '[]'" class="team-badge">
                <i class="fa-solid fa-users"></i> {{ getTeamName(props.dataItem.teamids) }}
              </span>
              <span v-else>Unassigned</span>
            </td>
          </template>
          <template v-slot:actionsCell="{ props }">
            <td class="actions-cell">
              <kbutton v-if="props.dataItem.status !== 'Completed'"
                       :theme-color="'primary'"
                       :size="'small'"
                       @click.stop="completeInternalTask(props.dataItem)"
                       class="action-btn complete-btn">
                Complete
              </kbutton>
              <span v-if="props.dataItem.status === 'Completed'" class="completed-badge">
                <i class="fa-solid fa-check-circle"></i> Completed
              </span>
            </td>
          </template>
        </Grid>
      </div>
    </k-dialog>
  </div>

  <transition name="dialogfade">
    <k-dialog v-if="showConfirmDialog" :title="confirmTitle" class="consumer-dialog confirm-dialog"
      @close="toggleConfirmDialog">
      <p class="confirm-msg">{{ confirmMsg }}</p>
      <p v-if="confirmNote" class="confirm-note">Note: {{ confirmNote }}</p>
      <k-dialog-actions>
        <kbutton class="dialog__btn dialog__btn--close" v-on:click="toggleConfirmDialog">No</kbutton>
        <kbutton class="dialog__btn dialog__btn--save" v-on:click="onActionConfirmed">Yes</kbutton>
      </k-dialog-actions>
    </k-dialog>
  </transition>
  <transition name="dialogfade">
    <k-dialog v-if="showErrorDialog" :title="errorTitle" class="error__dialog" @close="toggleErrorDialog">
      <p class="error-dialog__msg">{{ errorMsg }}</p>
    </k-dialog>
  </transition>

  <k-notification-group class="conditions__notification-container consumer">
    <k-fade :appear="successNotification">
      <k-notification v-if="successNotification" :type="{ style: 'success', icon: true }" :closable="true"
        @close="onCloseNotification('successNotification')">
        <span>{{ notificationMsg }}</span>
      </k-notification>
    </k-fade>
  </k-notification-group>
</template>

<script>
import { Grid, GridToolbar } from "@progress/kendo-vue-grid";
import { Checkbox, Input } from "@progress/kendo-vue-inputs";
import card from '../components/dashboardCard.vue';
import apiService from '../api/api.service.js';
import auth from '../authConfig.js';
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import { Button } from '@progress/kendo-vue-buttons';
import { TabStrip } from '@progress/kendo-vue-layout';
import { orderBy } from '@progress/kendo-data-query';
import 'vue-css-donut-chart/dist/vcdonut.css';
import { Notification, NotificationGroup } from "@progress/kendo-vue-notification";
import { Fade } from "@progress/kendo-vue-animation";
import { saveExcel } from '@progress/kendo-vue-excel-export';
import { process } from "@progress/kendo-data-query";
import aiframe from "../components/ai.vue";

import { Switch } from "@progress/kendo-vue-inputs";
import signalRService from '../api/signalr.service.js';
import "hammerjs";
import comingsoon from "@/components/comingsoon.vue";
import { VcDonut } from 'vue-css-donut-chart';

import {
  Chart,
  ChartArea,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesLabels,
} from "@progress/kendo-vue-charts";
import { Badge } from '@progress/kendo-vue-indicators';

const labelContent = function (e) {
  return `${e.category}: \n ${e.value}%`;
};
export default {
  data() {
    return {
      cardWidth: 0,
      alignment: 'start',
      azureId: '',
      userName: '',
      borrowerTaskSum: 0,
      checkBox: 'checkBox',
      cachedLoanLaunchMessagesPipelineQuery: null,
      confirmMsg: '',
      confirmNote: '',
      confirmFunction: null,
      confirmTitle: 'Please Confirm',
      dailyFeedLoaded: false,
      dailyFeedReceivedData: [],
      dailyFeedReceivedLoaded: false,
      dailyFeedReceivedSize: 0,
      dailyFeedSentData: [],
      dailyFeedSentLoaded: false,
      dailyFeedSentSize: 0,
      dateCell: "dateCell",
      debounceScrollTimeout: null,
      dialogData: [],
      disclosuresData: [],
      disclosuresLoaded: false,
      disclosuresTotal: 0,
      donutChartSize: 25,
      donutChartHoleSize: 60,
      errorMsg: '',
      errorTitle: '',
      expiringLocksBranchLoans: [],
      expiringLocksData: [],
      expiringLocksLoaded: false,
      expiringLocksTotal: 0,
      expiringLocksUserLoans: [],
      fetchParams: [],
      filter: {
        logic: 'and',
        filters: []
      },
      followUpToday: [],
      followUpTodayChartShare: 0,
      followUpTodayTotal: 0,
      gridDialog: false,
      gridDialogColumns: [],
      gridDialogData: [],
      incompleteAppsColumns: [
        { field: "appdate", title: "Application Date", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "borrowername", title: "Borrower Name", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "coborrowername", title: "Coborrower Name", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "loanofficername", title: "LO", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "orgid", title: "Branch", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "streetaddress", title: "Street Address", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "city", title: "City", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "state", title: "State", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "zip", title: "Zip", className: "clickable", sortable: true, columnMenu: true, filterable: true }

      ],
      incompleteAppsData: [],
      incompleteAppsLoaded: false,
      incompleteAppsChartShare: 0,
      incompleteAppSwitch: false,
      incompleteAppSwitchChecked: false,
      incompleteAppsTotal: 0,
      internalTasksData: [],
      internalTasksLoaded: [],
      internalTaskPending: [],
      internalTaskPendingChartShare: 0,
      internalTaskPendingTotal: 0,
      internalTaskRequested: [],
      internalTaskRequestedChartShare: 0,
      internalTaskRequestedTotal: 0,
      internalTaskSum: 0,
      isBranchManager: false,
      isCorp: false,
      isFetchingLatestLoanLaunchMessages: false,
      isGrouped: false,
      isLoanLaunchMessagesCollapsed: localStorage.getItem('isLoanLaunchMessagesCollapsed') === 'true',
      isLoanLaunchMessagesHovered: false,
      lar: '',
      larLoaded: false,
      loanBorrowers: [],
      loanData: [],
      newAppsColumns: [
        { field: "f364", title: "Loan Number", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "borrower_name", title: "Borrower Name", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "f11", title: "Address", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        { field: "logmsdatestarted", title: "Date", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true }
      ],
      newAppsData: [],
      newAppsLoaded: false,
      newAppsTotal: 0,
      notificationDialog: false,
      notificationMsg: '',
      loanLaunchMessages: [],
      loanLaunchMessagesIntervalId: null,
      openTaskData: [],
      openTaskRequested: [],
      openTaskRequestedChartShare: 0,
      openTaskRequestedTotal: 0,
      openTaskPending: [],
      openTaskPendingChartShare: 0,
      openTaskPendingTotal: 0,
      openTaskLoaded: false,
      outstandingTasksLoaded: false,
      openSigningTaskChartShare: 0,
      openSigningTaskData: [],
      openSigningTaskTotal: 0,
      pastDue: [],
      pastDueChartShare: 0,
      pastDueTotal: 0,
      tasksIAssigned: [],
      tasksIAssignedChartShare: 0,
      tasksIAssignedTotal: 0,
      tasksIAssignedLoaded: false,
      internalTaskTeams: [],
      teamTasks: [],
      teamTasksTotal: 0,
      teamTasksChartShare: 0,
      teamTasksLoaded: false,
      pendingTasksLoaded: false,
      pipelineCell: "pipelineCell",
      pipelineManagementSum: 1,
      pipelineSwitchChecked: false,
      pipelineTitle: "",
      searchWord: '',
      sendNotiButton: false,
      selected: 0,
      selectedField: 'selected',
      showErrorDialog: false,
      showConfirmDialog: false,
      sort: [],
      successNotification: false,
      tabs: [
        {
          title: 'Sent (0)',
          content: 'grid'
        },
        {
          title: 'Received (0)',
          content: 'grid'
        }
      ],
      tasksToSend: [],
      totalUnreadLoanLaunchMessages: null,
      token: '',
      unlockBranchLoans: [],
      unlockedLoansData: [],
      unlockedLoansLoaded: false,
      unlockedLoansTotal: 0,
      unlockUserLoans: [],
      userRoles: [],
      windowWidth: window.innerWidth,
      AITabs: [
        {
          title: 'Search UW Guidelines',
          content: 'UWGuides'
        },
        {
          title: 'Document Analyzer',
          content: 'docsum'
        },
        {
          title: 'Pipeline Insights',
          content: 'pipeline'
        },
        {
          title: 'Product Finder',
          content: 'product_finder'
        },
        //{
        //  title: 'Generate Marketing Content',
        //  content: 'genmarket'
        //},
        //{
        //  title: 'Recommend a Loan Product',
        //  content: 'recaloan'
        //},
        // {
        //  title: 'Loan Analyzer',
        //  content: 'sumaloan'
        //}
        //
      ],
      selectedTab: 0
    }
  },
  components: {
    'card': card,
    Chart,
    ChartArea,
    ChartLegend,
    ChartSeries,
    ChartSeriesItem,
    ChartSeriesLabels,
    checkbox: Checkbox,
    'dialog-actions-bar': DialogActionsBar,
    'k-fade': Fade,
    'k-switch': Switch,
    'Grid': Grid,
    'GridToolbar': GridToolbar,
    'k-dialog': Dialog,
    'k-input': Input,
    'k-notification': Notification,
    'k-dialog-actions': DialogActionsBar,

    'k-notification-group': NotificationGroup,
    'kbutton': Button,
    TabStrip,
    'vc-donut': VcDonut,
    'k-tabstrip': TabStrip,
    aiframe,
    comingsoon,
    Badge
  },
  computed: {
    selectedDataItems() {
      return this.gridDialogData.filter((item) => item.selected === true);
    },
    areAllSelected() {
      return (
        this.selectedDataItems.length === this.gridDialogData.length &&
        this.selectedDataItems.length !== 0
      );
    },
    borrowerSections() {
      return [
        { "label": "Outstanding Tasks", "value": this.openTaskRequestedChartShare, "color": "#ed766b" },
        { "label": "Pending Tasks", "value": this.openTaskPendingChartShare, "color": "#ede76b" },
        { "label": "Pending Borrower Signature", "value": this.openSigningTaskChartShare, "color": "#398b87" }
      ]
    },
    internalSections() {
      return [
        { "label": "Outstanding Loan Tasks", "value": this.internalTaskRequestedChartShare, "color": "#ed766b" },
        { "label": "Open Loan Tasks", "value": this.internalTaskPendingChartShare, "color": "#ede76b" },
        //{ "label": "Accepted Internal Tasks", "value": this.internalAcceptedTaskChartShare, "color": "#398b87" },
        { "label": "Due Today", "value": this.followUpTodayChartShare, "color": "#051d3a" },
        { "label": "Past Due", "value": this.pastDueChartShare, "color": "#b3130b" },
        { "label": "Tasks I Assigned", "value": this.tasksIAssignedChartShare, "color": "#6a4c93" },
        { "label": "Team Tasks", "value": this.teamTasksChartShare, "color": "#009688" }
      ]
    },
    disclosuresChartShare() {
      return this.disclosuresTotal / this.pipelineManagementSum;
    },
    docAnalyzerUrl() {
      const hostname = window.location.hostname;
      let aiServiceBaseUrl;

      if (hostname.startsWith('dev.') || hostname === 'localhost') {
        aiServiceBaseUrl = 'https://devai.goldstarfinancial.com';
      } else if (hostname === 'swiftapp.ai' || hostname === 'www.swiftapp.ai') {
        aiServiceBaseUrl = 'https://ai.goldstarfinancial.com';
      } else {
        // Default or fallback for other environments
        aiServiceBaseUrl = 'https://ai.goldstarfinancial.com'; // Or 'http://localhost:xxxx'
      }

      return `${aiServiceBaseUrl}/chat/summary`;
    },
    // width available for the chart = card minus legend + gap
    _chartAvailWidth() {
      const LEGEND = 175;
      const GAP = 1;
      const MIN_W = 20;
      const MAX_W = 280;

      const cw = this.cardWidth || window.innerWidth; // fallback

      const available = Math.max(0, cw - LEGEND - GAP);
      return Math.max(MIN_W, Math.min(MAX_W, available));
    },

    // Keep your simple API, but now based on the card
    donutChartAreaWidth() {
      // If you still want a hard breakpoint behavior, you can keep it:
      // return (this.cardWidth <= 439) ? Math.min(200, this._chartAvailWidth) : Math.min(280, this._chartAvailWidth);

      // Or let it flow continuously from the available width:
      return Math.round(this._chartAvailWidth);
    },

    donutChartAreaHeight() {
      const ASPECT = 0.78; // base ratio against width
      const MIN_HEIGHT = 100;
      const MAX_HEIGHT = 280;

      // Width-driven base height
      let height = this._chartAvailWidth * ASPECT;

      // Fine tune for screen height — use window.innerHeight
      // Lower screens → reduce slightly, tall screens → allow more room
      const screenFactor = Math.min(window.innerHeight / 700, 1); // scale down below 900px tall
      height = height * screenFactor;

      // Clamp to safe bounds
      return Math.round(Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, height)));
    },

    // Scale the slice size with the width (simple linear mapping)
    donutChartSize() {
      // base 20 at 280px, scale with available width
      const baseAt = 280;
      const base = 20;
      return Math.round((this._chartAvailWidth / baseAt) * base);
    },

    // Keep your hole size; or tweak slightly on very small cards
    donutChartHoleSize() {
      return (this._chartAvailWidth < 200) ? 18 : 40;
    },
    filteredTasksToSend() {
      let result = [];
      this.tasksToSend.forEach((task) => {
        if (!result.includes(task.id)) {
          result.push(task.id)
        }
      });
      return result
    },

    smallColumnWidth() {
      if (this.windowWidth <= 600) {
        return '70px';
      }
      else
        return '100px';
    },
    dailyFeedReceivedColumns() {
      if (this.windowWidth <= 430) {
        const columns = [
          { field: "loanNumber", title: "Loan Number", className: "clickable", sortable: true, columnMenu: true, width: this.smallColumnWidth, filterable: true },
          { field: "borrowerName", title: "Borrower Name", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "subject", title: "Subject", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "sender", title: "Sent by", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
        ];
        return columns;
      } else {
        const columns = [
          { field: "loanNumber", title: "Loan Number", className: "clickable", sortable: true, columnMenu: true, width: this.smallColumnWidth, filterable: true },
          { field: "borrowerName", title: "Borrower Name", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "subject", title: "Subject", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "sender", title: "Sent by", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "sent", title: "Date", className: "clickable", sortable: true, columnMenu: true, width: this.smallColumnWidth, filterable: true },
          { field: "sentTime", title: "Time", className: "clickable", sortable: true, columnMenu: true, width: this.smallColumnWidth, filterable: true }
        ];
        return columns;
      }

    },
    dailyFeedSentColumns() {
      if (this.windowWidth <= 430) {
        const columns = [
          { field: "loanNumber", title: "Loan Number", className: "clickable", sortable: true, columnMenu: true, width: this.smallColumnWidth, filterable: true },
          { field: "ContactName", title: "Recipient Name", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "ContactRole", title: "Role", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "subject", title: "Subject", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "receiver", title: "Sent to", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
        ];
        return columns;
      } else {
        const columns = [
          { field: "loanNumber", title: "Loan Number", className: "clickable", sortable: true, columnMenu: true, width: this.smallColumnWidth, filterable: true },
          { field: "contactName", title: "Recipient Name", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "contactRole", title: "Role", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "subject", title: "Subject", cell: 'subjectCell', className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "receiver", title: "Sent to", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "sent", title: "Date", className: "clickable", sortable: true, columnMenu: true, width: this.smallColumnWidth, filterable: true },
          { field: "sentTime", title: "Time", className: "clickable", sortable: true, columnMenu: true, width: this.smallColumnWidth, filterable: true }
        ];
        return columns;
      }

    },
    expiringLocksChartShare() {
      return this.expiringLocksTotal / this.pipelineManagementSum;
    },
    expiringLocksColumns() {
      if (this.windowWidth <= 430) {
        const columns = [
          { field: "name", title: "Name", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f2149", title: "Lock Date", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true },
          { field: "f2151", title: "Lock Expiration Date", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true },
        ];
        return columns;
      } else {
        const columns = [
          { field: "f364", title: "Loan Number", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "name", title: "Name", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f384", title: "Loan Purpose", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f2", title: "Loan Amount", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f3", title: "Interest Rate", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f2149", title: "Lock Date", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true },
          { field: "f1401", title: "Loan Program", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f2151", title: "Lock Expiration Date", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true },
          { field: "msstatus", title: "Last Completed Milestone", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "cust17fv", title: "Est. Closing Date", sortable: true, columnMenu: true, cell: "dateCell", filterable: true }


        ];
        return columns;
      }
    },
    newAppsChartShare() {
      return this.newAppsTotal / this.pipelineManagementSum;
    },
    openTaskColumns() {
      if (this.windowWidth <= 430) {
        const columns = [
          {
            field: 'selected',
            width: '45px',
            columnMenu: false,
            headerSelectionValue: this.areAllSelected,
            cell: 'checkBox'
          },
          { field: "title", title: "Title", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "borrower_name", title: "Borrower Name", filterable: true, className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "created", title: "Date Created", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true },
        ];
        return columns;
      } else {
        const columns = [
          {
            field: 'selected',
            width: '45px',
            columnMenu: false,
            headerSelectionValue: this.areAllSelected,
            cell: 'checkBox'
          },
          { field: "f364", title: "Loan Number", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "assignedto", title: "Assigned To", className: "clickable", sortable: true, columnMenu: true, filterable: true, cell: "assignedToCell" },
          { field: "borrower_name", title: "Borrower Name", filterable: true, className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "title", title: "Title", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "created", title: "Date Created", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true },
          { field: "age", title: "Task Age", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "cust17fv", title: "Est. Closing Date", sortable: true, columnMenu: true, cell: "dateCell", filterable: true }
        ];
        return columns;
      }
    },
    incompleteAppsChartShare() {
      this.incompleteAppsTotal / this.pipelineManagementSum;
    },
    internalTaskColumns() {
      if (this.windowWidth <= 430) {
        const columns = [

          { field: "title", title: "Title", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "assignedto", title: "Assigned To", filterable: true, className: "clickable", sortable: true, columnMenu: true, cell: "assignedToCell" },
          { field: "Created", title: "Date Created", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true },
          { field: "actions", title: "Actions", sortable: false, columnMenu: false, filterable: false, cell: "actionsCell", width: "200px" }
        ];
        return columns;
      } else {
        const columns = [

          { field: "loannumber", title: "Loan Number", sortable: true, columnMenu: false, filterable: true },
          { field: "borrowername", title: "Borrower Name", sortable: true, columnMenu: false, filterable: true },
          { field: "title", title: "Title", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "assignedto", title: "Assigned To", className: "clickable", sortable: true, columnMenu: true, filterable: true, cell: "assignedToCell" },
          { field: "created", title: "Date Created", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true },
          { field: "followupdate", title: "Follow Up Date", className: "clickable", sortable: true, columnMenu: true, cell: "dateCell", filterable: true },
          { field: "status", title: "Status", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "notes", title: "Notes", sortable: false, columnMenu: false, filterable: true },
          { field: "actions", title: "Actions", sortable: false, columnMenu: false, filterable: false, cell: "actionsCell", width: "200px" }
        ];
        return columns;
      }
    },
    pipelineManagementSections() {
      return [
        { "label": "Pending LO Signature", "value": this.disclosuresChartShare, "color": "#a4dad7" },
        { "label": "New Applications", "value": this.newAppsChartShare, "color": "#051d3a" },
        { "label": "Expiring Locks", "value": this.expiringLocksChartShare, "color": "#ed766b" },
        { "label": "Unlocked Loans", "value": this.unlockedLoansChartShare, "color": "#398b87" },
        { "label": "Incomplete Applications", "value": this.incompleteAppsChartShare, "color": "#FFFFFF" }

      ]
    },
    result: {
      get: function () {
        //const filteredData = this.gridDialogData;
        const filteredData = process(this.gridDialogData, { filter: this.filter }).data;
        return orderBy(filteredData, this.sort);
      }
    },
    tabs() {
      if (this.dailyFeedSentLoaded && this.dailyFeedReceivedLoaded) {
        return [
          {
            title: `Sent (${this.dailyFeedSentSize})`,
            content: 'grid'
          },
          {
            title: `Received (${this.dailyFeedReceivedSize})`,
            content: 'grid'
          }
        ];
      }
      return [
        {
          title: 'Sent (0)',
          content: 'grid'
        },
        {
          title: 'Received (0)',
          content: 'grid'
        }
      ]
    },
    unlockedLoansChartShare() {
      return this.unlockedLoansTotal / this.pipelineManagementSum;
    },
    unlockedLoansColumns() {
      if (this.windowWidth <= 430) {
        const columns = [
          { field: "f364", title: "Loan Number", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "name", title: "Name", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f2", title: "Loan Amount", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f3", title: "Interest Rate", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "msstatus", title: "Last Completed Milestone", className: "clickable", sortable: true, columnMenu: true, filterable: true },
        ];
        return columns;
      } else {
        const columns = [
          { field: "f364", title: "Loan Number", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "name", title: "Name", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f384", title: "Loan Purpose", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f2", title: "Loan Amount", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f3", title: "Interest Rate", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "f1401", title: "Loan Program", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "msstatus", title: "Last Completed Milestone", className: "clickable", sortable: true, columnMenu: true, filterable: true },
          { field: "cust17fv", title: "Est. Closing Date", sortable: true, columnMenu: true, cell: "dateCell", filterable: true }


        ];
        return columns;
      }
    },
    uwGuidesUrl() {
      const hostname = window.location.hostname;
      let aiServiceBaseUrl;

      if (hostname.startsWith('dev.') || hostname === 'localhost') {
        aiServiceBaseUrl = 'https://devai.goldstarfinancial.com';
      } else if (hostname === 'swiftapp.ai' || hostname === 'www.swiftapp.ai') {
        aiServiceBaseUrl = 'https://ai.swiftapp.ai';
      } else {
        aiServiceBaseUrl = 'https://ai.swiftapp.ai';
      }

      return `${aiServiceBaseUrl}/chat/gpt/iframe/`;
    },
    docAnalysisUrl() {
      const hostname = window.location.hostname;
      let aiServiceBaseUrl;

      if (hostname.startsWith('dev.') || hostname === 'localhost') {
        aiServiceBaseUrl = 'https://devai.goldstarfinancial.com';
      } else if (hostname === 'swiftapp.ai' || hostname === 'www.swiftapp.ai') {
        aiServiceBaseUrl = 'https://ai.swiftapp.ai';
      } else {
        aiServiceBaseUrl = 'https://ai.swiftapp.ai';
      }

      return `${aiServiceBaseUrl}/chat/summary`;
    },
    pipelineUrl() {
      const hostname = window.location.hostname;
      let aiServiceBaseUrl;

      if (hostname.startsWith('dev.') || hostname === 'localhost') {
        aiServiceBaseUrl = 'https://devai.goldstarfinancial.com';
      } else if (hostname === 'swiftapp.ai' || hostname === 'www.swiftapp.ai') {
        aiServiceBaseUrl = 'https://ai.swiftapp.ai';
      } else {
        aiServiceBaseUrl = 'https://ai.swiftapp.ai';
      }

      return `${aiServiceBaseUrl}/chat/gpt/iframe/pipeline`;
    },
    productFinderUrl() {
      const hostname = window.location.hostname;
      let aiServiceBaseUrl;

      if (hostname.startsWith('dev.') || hostname === 'localhost') {
        aiServiceBaseUrl = 'https://devai.goldstarfinancial.com';
      } else if (hostname === 'swiftapp.ai' || hostname === 'www.swiftapp.ai') {
        aiServiceBaseUrl = 'https://ai.swiftapp.ai';
      } else {
        aiServiceBaseUrl = 'https://ai.swiftapp.ai';
      }

      return `${aiServiceBaseUrl}/iframe/productFinder`;
    },
  },
  methods: {
    _updateCardWidth() {
      this.$nextTick(() => {
        const el = this.$refs.pmCard;
        if (!el) return;
        const cs = getComputedStyle(el);
        // Remove padding so we size the drawable area
        const padX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
        const w = Math.max(0, el.clientWidth - padX);
        if (Math.abs(w - this.cardWidth) >= 1) this.cardWidth = w;
      });
    },
    donutLabelContent(e) {
      // Category: Value (with thousands separators)
      const n = new Intl.NumberFormat().format(e.value ?? 0);
      return `${e.category}: ${n}`;
    },
    onTabSelected(evt) {
      this.selectedTab = evt.selected;
    },
    addRemoveTask(task) {
      console.log(task);
      const index = this.tasksToSend.findIndex(t => t === task);
      if (index !== -1) {
        this.tasksToSend.splice(index, 1);
      } else {
        console.log(task);
        this.tasksToSend.push(task);
      }
    },
    chartClickHandler(e) {
      if (e.dataItem.label === 'Outstanding Tasks') {
        this.showGridDialog(this.openTaskRequested, this.openTaskColumns, 'Outstanding Tasks');
      } else if (e.dataItem.label === 'Pending Tasks') {
        this.showGridDialog(this.openTaskPending, this.openTaskColumns, 'Pending Tasks');
      } else if (e.dataItem.label === 'Pending Borrower Signature') {
        this.showGridDialog(this.openSigningTaskData, this.openTaskColumns, 'Pending Borrower Signature');
      } else if (e.dataItem.label === 'Pending LO Signature') {
        this.showDisclosures;
      } else if (e.dataItem.label === 'New Applications') {
        this.showGridDialog(this.newAppsData, this.newAppsColumns, 'New Applications');
      } else if (e.dataItem.label === 'Expiring Locks') {
        this.showGridDialog(this.expiringLocksData, this.expiringLocksColumns, 'Expiring Locks');
      } else if (e.dataItem.label === 'Unlocked Loans') {
        this.showGridDialog(this.unlockedLoansData, this.unlockedLoansColumns, 'Unlocked Loans');
      } else if (e.dataItem.label === 'Outstanding Loan Tasks') {
        this.showGridDialog(this.internalTaskRequested, this.internalTaskColumns, 'Outstanding Loan Tasks')
      } else if (e.dataItem.label === 'Due Today') {
        this.showGridDialog(this.followUpToday, this.internalTaskColumns, 'Due Today')
      } else if (e.dataItem.label === 'Past Due') {
        this.showGridDialog(this.pastDue, this.internalTaskColumns, 'Past Due')
      } else if (e.dataItem.label === 'Open Loan Tasks') {
        this.showGridDialog(this.internalTaskPending, this.internalTaskColumns, 'Open Loan Tasks')
      } else if (e.dataItem.label === 'Tasks I Assigned') {
        this.showGridDialog(this.tasksIAssigned, this.internalTaskColumns, 'Tasks I Assigned')
      } else if (e.dataItem.label === 'Team Tasks') {
        this.showGridDialog(this.teamTasks, this.internalTaskColumns, 'Team Tasks')
      }
    },
    async checkGrouping(azureId) {
      // var groupings = await apiService.GetGrouping(azureId, this.token.accessToken);
      // this.isGrouped = groupings.data.data.length > 0 ? true : false;

    },
    exportExcel() {
      const excelColumns = this.gridDialogColumns.map(col => {
        return {
          field: col.field,
          title: col.title || col.field,
          width: col.width,
          format: col.format || undefined,
        };
      });
      const dataToExport = this.gridDialogData;
      saveExcel({
        data: dataToExport,
        fileName: `${this.pipelineTitle}.xlsx`,
        columns: excelColumns,
      });
    },
    async fetchData(dataContainer, dataLoaded, apiFunction, ...apiArgs) {
      try {
        const tokenResponse = await auth.acquireTokenResponse(); // Get Auth Token
        if (!tokenResponse) throw new Error("Failed to acquire token response");
        const response = await apiFunction(...apiArgs, tokenResponse.accessToken);

        const data = response.data;
        if (data && Array.isArray(data.data)) {
          this[dataContainer] = data.data;
        } else {
          console.error("No valid data received from API");
          this[dataContainer] = [];
        }
      }
      catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this[dataLoaded] = true;
      }
    },
    async fetchLoanLaunchMessages(fetchNewer = false) {

      if (this.isFetchingLatestLoanLaunchMessages) return;

      this.isFetchingLatestLoanLaunchMessages = true;

      let referenceMessage = null;

      if (this.loanLaunchMessages?.length > 0) {
        referenceMessage = (fetchNewer ? this.loanLaunchMessages[0] : this.loanLaunchMessages[this.loanLaunchMessages.length - 1]);
      }

      let req = {
        query: this.cachedLoanLaunchMessagesPipelineQuery,
        AzureId: this.azureId,
        LastMessageId: referenceMessage?.id,
        LastSentDate: referenceMessage?.sent,
        TopCount: 35,
        IsForward: fetchNewer
      };

      let newMessages = await this.getLoanLaunchMessages(req);

      if (newMessages?.length > 0) {
        if (fetchNewer) {
          this.loanLaunchMessages.unshift(...newMessages);
        } else {
          this.loanLaunchMessages.push(...newMessages);
        }

        this.scrollElementUpIfAtBottom();
      }

      this.isFetchingLatestLoanLaunchMessages = false;
    },
    async fetchUnreadLoanLaunchMessages(fetchNewer = false) {

      let req = {
        query: this.cachedLoanLaunchMessagesPipelineQuery,
        AzureId: this.azureId,
        LastMessageId: null,
        LastSentDate: null,
        TopCount: 0
      };

      await this.getUnreadLoanLaunchMessages(req);
    },
    filterChange(e) {
      this.filter = e.filter;
    },
    formatDate(props) {
      const dateValue = this.getNestedValue(props.field, props.dataItem);
      if (dateValue) {
        // Convert to Date object if it's not already one
        let date = dateValue instanceof Date ? dateValue : new Date(dateValue);

        // Check if the date is valid
        if (isNaN(date.getTime())) {
          return null;
        }

        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const day = String(date.getDate()).padStart(2, '0');
        const year = date.getFullYear();

        // Return formatted mm/dd/yyyy
        return `${month}/${day}/${year}`;
      }
      return null;
    },
    getTeamName(teamIds) {
      if (!teamIds || teamIds === '[]' || !this.internalTaskTeams?.length) {
        return 'Team Task';
      }
      try {
        const parsedIds = JSON.parse(teamIds);
        if (!Array.isArray(parsedIds) || parsedIds.length === 0) {
          return 'Team Task';
        }
        // Find matching team names
        const teamNames = parsedIds
          .map(id => {
            const team = this.internalTaskTeams.find(t =>
              t.id === id || t.Id === id || t.teamId === id || t.TeamId === id
            );
            return team?.teamname || team?.TeamName || team?.teamName || team?.name || null;
          })
          .filter(name => name);

        return teamNames.length > 0 ? teamNames.join(', ') : 'Team Task';
      } catch (e) {
        return 'Team Task';
      }
    },
    formatDateTimeShort(dateString) {
      if (!dateString) return "";

      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        return "Invalid Date";
      }

      return new Intl.DateTimeFormat("en-US", {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true
      }).format(date);
    },
    formatNumberWithCommas(value) {
      const parsed = parseInt(value, 10);
      if (isNaN(parsed)) return value;
      return parsed.toLocaleString();
    },
    async GetExpiringLocks() {
      this.expiringLocksBranchLoans = [];
      this.expiringLocksUserLoans = [];

      try {
        const tokenResponse = await auth.acquireTokenResponse(); // Get Auth Token

        if (!tokenResponse) throw new Error("Failed to acquire token response");

        const response = await apiService.GetExpiringLocks(this.azureId, tokenResponse.accessToken);

        const expiringLocksData = response.data.data;
        if (expiringLocksData) {
          if (this.isBranchManager || this.isCorp) {
            this.expiringLocksBranchLoans = expiringLocksData?.branchloans?.map(t => ({
              ...t,
              cust17fv: t.cust17fv ? new Date(t.cust17fv) : null
            })) || [];
          }

          this.expiringLocksUserLoans = expiringLocksData?.userloans?.map(t => ({
            ...t,
            cust17fv: t.cust17fv ? new Date(t.cust17fv) : null
          })) || [];

          if (this.pipelineSwitchChecked && (this.isBranchManager || this.isCorp)) {
            if (expiringLocksData?.branchloans) {
              this.expiringLocksData = this.expiringLocksBranchLoans;
            }

          } else {
            if (expiringLocksData?.userloans) {
              this.expiringLocksData = this.expiringLocksUserLoans;
            }
          }

          this.expiringLocksTotal = this.expiringLocksData.length;
          this.pipelineManagementSum += this.unlockedLoansTotal;
        } else {
          console.error("No valid data received from API");
          this.onRequestError('Get Unlock Loans Error', "No valid data received from API")

        }
      }
      catch (error) {
        this.onRequestError('Get Unlock Loans Error', error.message)

      } finally {
        this.isLoading = false;
      }
    },
    async getLar() {
      this.larLoaded = false;
      try {
        // Prefer cached azure data written by App.vue
        const cached = localStorage.getItem("user_azure_data");
        if (cached) {
          const parsed = JSON.parse(cached);
          this.lar = parsed?.onPremisesExtensionAttributes?.extensionAttribute1 ?? null;
          this.larLoaded = this.lar !== null;
          return;
        }
        // Fallback (deduped by api.service cache)
        var result = await apiService.GetUsersAzureData(this.azureId, this.token.accessToken);
        this.lar = result.data.data.onPremisesExtensionAttributes.extensionAttribute1;
        if (this.lar !== null) {
          this.larLoaded = true;
        }
      } catch {
        this.lar = null;
        this.larLoaded = false;
      }
    },
    async getLoanLaunchMessages(req) {

      let res = await apiService.GetLoanLaunchMessagesWithReadStatus(req, this.token.accessToken);

      if (res?.data?.data?.query) {
        this.cachedLoanLaunchMessagesPipelineQuery = res?.data?.data?.query;
      }

      return res?.data?.data?.messages ?? [];
    },
    getNestedValue: function (fieldName, dataItem) {
      const path = fieldName.split('.');
      let data = dataItem;
      path.forEach((p) => {
        data = data ? data[p] : undefined;
      });
      return data;
    },
    async GetUnlockedLoans() {
      this.unlockBranchLoans = [];
      this.unlockUserLoans = [];

      try {
        const tokenResponse = await auth.acquireTokenResponse(); // Get Auth Token

        if (!tokenResponse) throw new Error("Failed to acquire token response");

        const response = await apiService.GetUnlockedLoans(this.azureId, tokenResponse.accessToken);

        const unlockData = response.data.data;
        if (unlockData) {
          if (this.isBranchManager || this.isCorp) {
            this.unlockBranchLoans = unlockData?.branchloans?.map(t => ({
              ...t,
              cust17fv: t.cust17fv ? new Date(t.cust17fv) : null
            })) || [];
          }

          this.unlockUserLoans = unlockData?.userloans?.map(t => ({
            ...t,
            cust17fv: t.cust17fv ? new Date(t.cust17fv) : null
          })) || [];

          if (this.pipelineSwitchChecked && (this.isBranchManager || this.isCorp)) {
            if (unlockData?.branchloans) {
              this.unlockedLoansData = this.unlockBranchLoans;
            }

          } else {
            if (unlockData?.userloans) {
              this.unlockedLoansData = this.unlockUserLoans;
            }
          }
          this.unlockedLoansTotal = this.unlockedLoansData.length;
          this.pipelineManagementSum += this.unlockedLoansTotal;
        } else {
          console.error("No valid data received from API");
          this.onRequestError('Get Unlock Loans Error', "No valid data received from API")

        }
      }
      catch (error) {
        this.onRequestError('Get Unlock Loans Error', error.message)

      } finally {
        this.isLoading = false;
      }
    },
    // Only used to update total count
    async getUnreadLoanLaunchMessages(req) {

      let res = await apiService.GetUnreadLoanLaunchMessages(req, this.token.accessToken);

      this.totalUnreadLoanLaunchMessages = res?.data?.data?.totalUnread;
    },
    async GetRoles() {
      // Roles are fetched centrally by App.vue and stored in localStorage.
      // Read from there instead of making a duplicate API call.
      try {
        const raw = localStorage.getItem('active_user_roles')
        let roles = []
        if (raw) {
          try { roles = JSON.parse(raw) } catch { roles = String(raw).split(',') }
        }
        if (Array.isArray(roles)) {
          this.isBranchManager = roles.includes("Branch Manager");
          this.isCorp = roles.includes("Corp");
        }
      } catch (error) {
        console.error("Error reading roles:", error);
      }
    },
    getScreenWidth() {
      this.windowWidth = window.innerWidth;
    },
    isToday(dateString) {
      const today = new Date();
      const inputDate = new Date(dateString);

      return (
        inputDate.getDate() === today.getDate() &&
        inputDate.getMonth() === today.getMonth() &&
        inputDate.getFullYear() === today.getFullYear()
      );
    },
    isPastDue(dateString) {
      const inputDate = new Date(dateString);
      const currentDate = new Date();

      // Normalize dates to ignore time
      inputDate.setHours(0, 0, 0, 0);
      currentDate.setHours(0, 0, 0, 0);

      return inputDate < currentDate;
    },
    async markAllUnreadLoanLaunchMessagesAsRead() {
      let tmpTotal = this.totalUnreadLoanLaunchMessages;

      this.totalUnreadLoanLaunchMessages = null;

      var res = await apiService.MarkAllLoanLaunchMessagesRead(this.azureId, this.token.accessToken);

      if (res.data.issuccess) {
        this.loanLaunchMessages.forEach(m => m.isread = true);
        this.totalUnreadLoanLaunchMessages = 0;
      } else {
        this.totalUnreadLoanLaunchMessages = tmpTotal;
      }

    },
    navigateToLoan(dataItem) {
      var swiftURL = process.env.VUE_APP_SWIFT_URL;
      if (this.pipelineTitle.includes("Loan Tasks") || this.pipelineTitle.includes("Due Today") || this.pipelineTitle.includes("Past Due") || this.pipelineTitle.includes("Tasks I Assigned") || this.pipelineTitle === "Team Tasks") {
        window.open(`${dataItem.dataItem.tasklink}`, '_blank');
      } else if (this.pipelineTitle.includes("Incomplete Applications")) {
        //do nothing for now, I have no idea what this should do or why i decided to handle every set of data with the same grid inside the same dialog this is a nightmare someone please wake me up
      }
      else if (this.pipelineTitle.includes("New Applications")) {
        window.open(`https://swift.goldstarfinancial.com/ConsumerPortal?id=${dataItem.dataItem.id}&swiftprocessing=true`, '_blank'); //open in new tab
      }
      else {
        if (dataItem.f364) {
          window.open(`https://swift.goldstarfinancial.com/ConsumerPortal?id=${dataItem.id}&swiftprocessing=true&taskId=${dataItem.task_id}&taskOpen=true`, '_blank'); //open in new tab
        }
        else {
          console.log(dataItem.dataItem.tasklink);
          window.open(`https://swift.goldstarfinancial.com/ConsumerPortal?id=${dataItem.dataItem.id}&swiftprocessing=true&taskId=${dataItem.dataItem.task_id}&taskOpen=true`, '_blank'); //open in new tab
        }
      }
    },
    onActionConfirmed() {
      this[this.confirmFunction]();
      this.areAllSelected = false;
      this.gridDialogData.forEach(t => t.selected = false);
      this.toggleConfirmDialog();
    },
    onFilter() {
      const keyword = this.searchWord.toLowerCase().trim();
      if (!keyword) {
        // Reset the grid data to its original state
        this.gridDialogData = this.originalGridData || [];
        return;
      }
      // Get the fields of the available columns
      const searchableFields = this.gridDialogColumns.map(col => col.field);
      // Perform filtering only on available columns
      this.gridDialogData = this.originalGridData.filter((item) =>
        searchableFields.some((field) => {
          const value = item[field];
          return value && String(value).toLowerCase().includes(keyword);
        })
      );
    },
    onGridDialogClose() {
      this.gridDialogData.forEach(t => t.selected = false);
      this.tasksToSend = [];
      this.gridDialog = !this.gridDialog;
      this.sendNotiButton = false;
    },
    onHeaderSelectionChange(event) {
      if (event.event) {
        let checked = event.event.target.checked;
        this.gridDialogData = this.gridDialogData.map((item) => { return { ...item, selected: checked } });
        this.gridDialogData.forEach((item) => {
          if (item.selected) {
            const index = this.tasksToSend.findIndex(t => t.task_id === item.task_id);
            if (index === -1) {
              this.tasksToSend.push(item)
            }
          } else {
            const index = this.tasksToSend.findIndex(t => t.task_id === item.task_id);
            if (index !== -1) {
              this.tasksToSend.splice(index, 1);
            }
          }
        })
      }
    },
    onLoanlaunchMessageClicked(message) {
      const baseUrl = 'https://swift.goldstarfinancial.com';
      window.open(`${baseUrl}/ConsumerPortal/?id=${message.loanid}`, '_blank');

      setTimeout(() => {
        message.isread = true;
      }, 1000);
    },
    onRequestError(errorTitle, errorMsg) {
      //this.isLoading = false;

      this.errorTitle = errorTitle;

      if (errorMsg) {
        this.errorMsg = errorMsg;
      } else {
        this.errorMsg = 'Please try again';
      }

      this.showErrorDialog = true;
    },
    onSendTaskNotification() {
      this.confirmMsg = 'Are you sure you would like to send all borrowers on file a notification of all Requested tasks?';
      this.confirmNote = 'Borrowers must have a valid email on file to receive the notification';
      this.confirmFunction = 'sendTaskNotification';
      this.toggleConfirmDialog();
    },
    onScrollLoanLaunchMessages() {
      if (this.debounceScrollTimeout) {
        clearTimeout(this.debounceScrollTimeout);
      }

      this.debounceScrollTimeout = setTimeout(() => {
        const el = this.$refs.scrollContainer;
        if (!el) return;

        const scrollTop = el.scrollTop;
        const scrollHeight = el.scrollHeight;
        const clientHeight = el.clientHeight;

        const isNearBottom = scrollTop + clientHeight >= scrollHeight - 10;

        if (isNearBottom) {
          this.fetchLoanLaunchMessages();
        }
      }, 300);
    },
    onSelectionChange(dataItem) {
      dataItem[this.selectedField] = !dataItem[this.selectedField];
      console.log(dataItem);
      this.addRemoveTask(dataItem);
    },
    onSelect(e) {
      this.selected = e.selected;
    },
    onIncompleteAppSwitchChange() {
      this.incompleteAppSwitchChecked = !this.incompleteAppSwitchChecked;
      this.incompleteAppSwitchChecked ? this.setCookie('incompleteAppSwitch', 'on') : this.setCookie('incompleteAppSwitch', 'off');
      this.incompleteAppsData = [];
      this.incompleteAppsLoaded = false;
      this.incompleteAppsChartShare = 0;
      this.incompleteAppsTotal = 0;
      this.pipelineManagementSum = this.newAppsTotal + this.expiringLocksTotal + this.disclosuresTotal + this.unlockedLoansTotal;
      if (this.incompleteAppSwitchChecked) {
        this.fetchData('incompleteAppsData', 'incompleteAppsLoaded', apiService.GetUncompletedAppsByBranchGroup, this.azureId)
          .then(() => {
            this.incompleteAppsTotal = this.incompleteAppsData.length;
            this.pipelineManagementSum += this.incompleteAppsTotal;
            this.gridDialogData = this.incompleteAppsData;
          });
      } else {
        this.fetchData('incompleteAppsData', 'incompleteAppsLoaded', apiService.GetUncompletedAppsByLOID, this.azureId)
          .then(() => {
            this.incompleteAppsTotal = this.incompleteAppsData.length;
            this.pipelineManagementSum += this.incompleteAppsTotal;
            this.gridDialogData = this.incompleteAppsData;

          });
      }

    },

    async onPipelineSwitchChange() {
      this.pipelineSwitchChecked = !this.pipelineSwitchChecked;

      if (this.pipelineSwitchChecked) {
        //UnLocks
        this.unlockedLoansData = this.unlockBranchLoans;

        this.pipelineManagementSum -= this.unlockUserLoans.length;
        this.unlockedLoansTotal = this.unlockBranchLoans.length;
        this.pipelineManagementSum += this.unlockedLoansTotal;

        //Expiring Locks
        this.expiringLocksData = this.expiringLocksBranchLoans;

        this.pipelineManagementSum -= this.expiringLocksUserLoans.length;
        this.expiringLocksTotal = this.expiringLocksBranchLoans.length;
        this.pipelineManagementSum += this.expiringLocksTotal;
      } else {
        //UnLocks
        this.unlockedLoansData = this.unlockUserLoans

        this.pipelineManagementSum -= this.unlockBranchLoans.length;
        this.unlockedLoansTotal = this.unlockUserLoans.length;
        this.pipelineManagementSum += this.unlockedLoansTotal;

        //Expiring Locks
        this.expiringLocksData = this.expiringLocksUserLoans;

        this.pipelineManagementSum -= this.expiringLocksBranchLoans.length;
        this.expiringLocksTotal = this.expiringLocksUserLoans.length;
        this.pipelineManagementSum += this.expiringLocksTotal;
      }
    },
   onTaskSwitchChange() {
  this.taskSwitchChecked = !this.taskSwitchChecked;
  this.taskSwitchChecked ? this.setCookie('taskSwitch', 'on') : this.setCookie('taskSwitch', 'off');

  this.internalTasksLoaded = false;
  this.followUpTodayTotal = 0;
  this.internalTasksData = [];
  this.internalTaskPending = [];
  this.internalTaskRequested = [];
  this.followUpToday = [];
  this.internalTaskPendingTotal = 0;
  this.internalTaskRequestedTotal = 0;
  this.pastDue = [];
  this.pastDueTotal = 0;
  this.tasksIAssigned = [];
  this.tasksIAssignedTotal = 0;
  this.teamTasks = [];
  this.teamTasksTotal = 0;

  this.openTaskData = [];
  this.openTaskRequested = [];
  this.openTaskPending = [];
  this.openSigningTaskData = [];
  this.openTaskRequestedTotal = 0;
  this.openTaskPendingTotal = 0;
  this.openSigningTaskTotal = 0;
  this.borrowerTaskSum = 0;
  this.openTaskLoaded = false;

  this.fetchData(
    'openTaskData',
    'openTaskLoaded',
    apiService.GetSwiftDashboardData,
    this.azureId,
    this.taskSwitchChecked,
    this.taskSwitchChecked
  ).then(() => this.processOpenTasks());

  if (this.taskSwitchChecked) {
    this.fetchData('internalTasksData', 'internalTasksLoaded', apiService.GetGroupingInternalTasks, this.azureId)
      .then(() => this.processInternalTasks());
  } else {
    this.fetchData('internalTasksData', 'internalTasksLoaded', apiService.GetInternalTasks, this.azureId)
      .then(() => this.processInternalTasks());
  }

  this.fetchData('tasksIAssigned', 'tasksIAssignedLoaded', apiService.GetTasksIAssigned, this.azureId)
    .then(() => {
      this.tasksIAssignedTotal = this.tasksIAssigned.length;
      this.tasksIAssignedChartShare = this.tasksIAssignedTotal / (this.internalTaskSum + this.tasksIAssignedTotal);
    });

  this.fetchTeamTasks();
},
    async processDailyFeed() {
      for (let i = this.dailyFeedSentData.length - 1; i >= 0; i--) {
        if (this.dailyFeedSentData[i].sent_true === "FALSE") {
          const item = this.dailyFeedSentData.splice(i, 1)[0];
          this.dailyFeedReceivedData.unshift(item);
        }
      }
      this.dailyFeedSentSize = this.dailyFeedSentData.length;
      this.dailyFeedReceivedSize = this.dailyFeedReceivedData.length;
      this.dailyFeedSentLoaded = true;
      this.dailyFeedReceivedLoaded = true;
    },
    async processInternalTasks() {
      this.internalTaskSum = this.internalTasksData.length;
      for (let i = this.internalTasksData.length - 1; i >= 0; i--) {
        const item = this.internalTasksData.splice(i, 1)[0];
        if (this.isToday(item.followupdate) && item.status !== "Completed") {
          this.followUpToday.unshift(item);
          this.followUpTodayTotal++;
        }
        if (this.isPastDue(item.followupdate) && item.status !== "Completed") {
          this.pastDue.unshift(item);
          this.pastDueTotal++;
        }
        if (item.status === "Pending") {
          //Have to do this because SOMEONE wanted to change what these were called after a bunch of stuff had already been built around what they used to be called
          item.status = "Open";

          this.internalTaskPending.unshift(item);
          this.internalTaskRequested.unshift(item);
          this.internalTaskRequestedTotal++;
          this.internalTaskPendingTotal++;
        }
        if (item.status === "Requested") {
          //Read the above comment
          item.status = "Assigned";

          this.internalTaskRequested.unshift(item);
          this.internalTaskRequestedTotal++;
        } else if (item.status === "In Process") {
          this.internalTaskRequested.unshift(item);
          this.internalTaskRequestedTotal++;
        } else if (item.status === "Completed") {
          this.internalTaskSum--;
        }
        if (item.followupdate) {
          item.followupdate = new Date(item.followupdate);
        }
        item.created = item.created ? new Date(item.created) : null;
        this.internalTaskPendingChartShare = this.internalTaskPendingTotal / (this.internalTaskSum + this.followUpTodayTotal);
        this.internalTaskRequestedChartShare = this.internalTaskRequestedTotal / (this.internalTaskSum + this.followUpTodayTotal);
        this.followUpTodayChartShare = this.followUpTodayTotal / (this.internalTaskSum + this.followUpTodayTotal);
        this.pastDueChartShare = this.pastDueTotal / (this.internalTaskSum + this.pastDueTotal);
      }
    },
    async fetchTeamTasks() {
      try {
        const tokenResponse = await auth.acquireTokenResponse();
        if (!tokenResponse) return;

        // Fetch teams data for name lookup
        const teamsResponse = await apiService.GetInternalTaskTeams(tokenResponse.accessToken);
        if (teamsResponse?.data?.data) {
          this.internalTaskTeams = Object.values(teamsResponse.data.data);
        } else if (teamsResponse?.data && typeof teamsResponse.data === 'object') {
          this.internalTaskTeams = Object.values(teamsResponse.data);
        }

        // Use the new GetTeamTasks endpoint that fetches tasks where user is a team member
        const response = await apiService.GetTeamTasks(this.azureId, tokenResponse.accessToken);

        if (response?.data?.data) {
          this.teamTasks = response.data.data;
        } else if (response?.data && Array.isArray(response.data)) {
          this.teamTasks = response.data;
        } else {
          this.teamTasks = [];
        }

        // Process dates for grid display
        this.teamTasks.forEach(task => {
          if (task.followupdate) task.followupdate = new Date(task.followupdate);
          if (task.created) task.created = new Date(task.created);
        });

        this.teamTasksTotal = this.teamTasks.length;
        this.teamTasksChartShare = this.teamTasksTotal / (this.internalTaskSum + this.teamTasksTotal || 1);
        this.teamTasksLoaded = true;
      } catch (error) {
        console.error('Error fetching team tasks:', error);
        this.teamTasksLoaded = true;
      }
    },
    async processOpenTasks() {
      this.borrowerTaskSum = this.openTaskData.length;
      for (let i = this.openTaskData.length - 1; i >= 0; i--) {
        const item = this.openTaskData.splice(i, 1)[0];
        item.created = item.created ? new Date(item.created) : null;
        item.cust17fv = item.cust17fv ? new Date(item.cust17fv) : null;
        if (item.status === "Pending") {
          this.openTaskPending.unshift(item);
          this.openTaskPendingTotal++;

        } else if (item.status === "Requested" && item.signingtask === "True") {
          this.openSigningTaskData.unshift(item);
          this.openSigningTaskTotal++;
        }
        else if (item.status === "Requested" && item.signingtask === "False") {
          this.openTaskRequested.unshift(item);
          this.openTaskRequestedTotal++;
        }
      }
      this.openTaskPendingChartShare = this.openTaskPendingTotal / this.borrowerTaskSum;
      this.openSigningTaskChartShare = this.openSigningTaskTotal / this.borrowerTaskSum;
      this.openTaskRequestedChartShare = this.openTaskRequestedTotal / this.borrowerTaskSum;
      this.outstandingTasksLoaded = true;
      this.pendingTasksLoaded = true;
    },
    scrollElementUpIfAtBottom(offset = 0) {
      const el = this.$refs.scrollContainer;
      if (!el) return;

      const scrollTop = el.scrollTop;
      const scrollHeight = el.scrollHeight;
      const clientHeight = el.clientHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 10;

      if (isAtBottom) {
        el.scrollTop = scrollTop - offset;
      }
    },
    async sendTaskNotification() {

      try {
        for (let t of this.filteredTasksToSend) {

          console.log("response " + this.token.accessToken);

          apiService.CreateManualBorrowerTaskNotifications(t, this.token.accessToken)
            .then(res => {
              //this.isLoading = false;
              this.showNotification('Notification(s) sent successfully');
            }).catch(error => {
              this.errorTitle = 'Failed to Send Notifications';

              if (error.response?.data) {
                this.errorMsg = "Error: \n\n" + error.response?.data?.data;
              } else {
                this.errorMsg = '';
              }

              this.onRequestError(this.errorTitle, this.errorMsg);
            });
        }
      } catch (ex) {
        console.error("Error fetching data:", ex);

      }
    },

    setCookie(id, value) {
      document.cookie = id + '=' + value;
    },
    getCookie(id) {
      let value = document.cookie.match('(^|;)?' + id + '=([^;]*)(;|$)');
      return value ? value[2] : null;
    },
    showDisclosures() {
      window.open('https://www.encompassloconnect.com/package-pipeline', '_blank', 'location=yes, scrollbars=yes,status=yes');
    },
    showGridDialog(gridData, gridColumns, pipelineTitle, notiButton, groupSwitch) {
      this.originalGridData = [...gridData];
      this.gridDialog = true;
      this.gridDialogData = gridData;
      this.gridDialogColumns = gridColumns;
      this.pipelineTitle = pipelineTitle;
      this.sendNotiButton = notiButton;
      this.incompleteAppSwitch = groupSwitch;
    },
    showNotification(notificationMsg) {
      this.notificationMsg = notificationMsg;

      this.successNotification = true;

      setTimeout(() => {
        this.successNotification = false;
      }, 4000);
    },
    showNotificationDialog(dataItem) {
      this.notificationDialog = true;
      this.dialogData = dataItem;
    },
    async approveInternalTask(task) {
      try {
        const tokenResponse = await auth.acquireTokenResponse();
        if (!tokenResponse || !tokenResponse.accessToken) {
          throw new Error('Failed to acquire authentication token');
        }

        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        };
        const currentDateTime = new Intl.DateTimeFormat('en-US', options).format(new Date());
        const currentUser = tokenResponse.account.name;

        const updatedParams = {
          ...task,
          completed: false,
          status: 'Pending',
          lastUpdated: `${currentDateTime} by ${currentUser}`,
        };

        await apiService.UpsertInternalAssignedTask(updatedParams, tokenResponse.accessToken);
        this.showNotification(`Task "${task.title}" approved successfully`);

        // Refresh the internal tasks data
        await this.refreshInternalTasks();
      } catch (error) {
        console.error('Error approving task:', error);
        const errorMsg = error.response?.data?.data || error.message || 'Failed to approve task';
        this.errorTitle = 'Error Approving Task';
        this.errorMsg = errorMsg;
        this.toggleErrorDialog();
      }
    },
    async completeInternalTask(task) {
      try {
        const tokenResponse = await auth.acquireTokenResponse();
        if (!tokenResponse || !tokenResponse.accessToken) {
          throw new Error('Failed to acquire authentication token');
        }

        const options = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        };
        const currentDateTime = new Intl.DateTimeFormat('en-US', options).format(new Date());
        const currentUser = tokenResponse.account.name;

        const updatedParams = {
          ...task,
          completed: true,
          status: 'Completed',
          lastUpdated: `${currentDateTime} by ${currentUser}`,
        };

        await apiService.UpsertInternalAssignedTask(updatedParams, tokenResponse.accessToken);

        // Refresh the internal tasks data
        await this.refreshInternalTasks();
      } catch (error) {
        console.error('Error completing task:', error);
        const errorMsg = error.response?.data?.data || error.message || 'Failed to complete task';
        this.errorTitle = 'Error Completing Task';
        this.errorMsg = errorMsg;
        this.toggleErrorDialog();
      }
    },
    async refreshInternalTasks() {
      // Clear current data
      this.followUpTodayTotal = 0;
      this.internalTasksData = [];
      this.internalTaskPending = [];
      this.internalTaskRequested = [];
      this.followUpToday = [];
      this.internalTaskPendingTotal = 0;
      this.internalTaskRequestedTotal = 0;
      this.pastDue = [];
      this.pastDueTotal = 0;
      this.tasksIAssigned = [];
      this.tasksIAssignedTotal = 0;

      // Reload data based on switch state
      if (this.taskSwitchChecked) {
        await this.fetchData('internalTasksData', 'internalTasksLoaded', apiService.GetGroupingInternalTasks, this.azureId);
        await this.processInternalTasks();
      } else {
        await this.fetchData('internalTasksData', 'internalTasksLoaded', apiService.GetInternalTasks, this.azureId);
        await this.processInternalTasks();
      }

      // Reload Tasks I Assigned
      await this.fetchData('tasksIAssigned', 'tasksIAssignedLoaded', apiService.GetTasksIAssigned, this.azureId);
      this.tasksIAssignedTotal = this.tasksIAssigned.length;
      this.tasksIAssignedChartShare = this.tasksIAssignedTotal / (this.internalTaskSum + this.tasksIAssignedTotal);

      // Reload Team Tasks
      await this.fetchTeamTasks();

      // Close and reopen the dialog if it's currently showing internal tasks
      if (this.gridDialog && (this.pipelineTitle.includes('Loan Task') || this.pipelineTitle === 'Tasks I Assigned' || this.pipelineTitle === 'Due Today' || this.pipelineTitle === 'Past Due' || this.pipelineTitle === 'Team Tasks')) {
        this.gridDialog = false;
        setTimeout(() => {
          // Determine which data to show based on the title
          let dataToShow = [];
          if (this.pipelineTitle === 'Outstanding Loan Tasks') {
            dataToShow = this.internalTaskRequested;
          } else if (this.pipelineTitle === 'Open Loan Tasks') {
            dataToShow = this.internalTaskPending;
          } else if (this.pipelineTitle === 'Due Today') {
            dataToShow = this.followUpToday;
          } else if (this.pipelineTitle === 'Past Due') {
            dataToShow = this.pastDue;
          } else if (this.pipelineTitle === 'Tasks I Assigned') {
            dataToShow = this.tasksIAssigned;
          } else if (this.pipelineTitle === 'Team Tasks') {
            dataToShow = this.teamTasks;
          }
          this.showGridDialog(dataToShow, this.internalTaskColumns, this.pipelineTitle);
        }, 100);
      }
    },
    sortChangeHandler(e) {
      this.sort = e.sort;
    },
    toFuzzyTime: (dateInput) => {
      const now = new Date();
      const then = new Date(dateInput);
      const seconds = Math.floor((now - then) / 1000);

      const MINUTE = 60;
      const HOUR = 60 * MINUTE;
      const DAY = 24 * HOUR;
      const WEEK = 7 * DAY;
      const MONTH = 30 * DAY;
      const YEAR = 365 * DAY;

      if (seconds < 5) return 'Just now';
      if (seconds < 60) return 'Seconds ago';
      if (seconds < 90) return 'A minute ago';
      if (seconds < HOUR) return `${Math.floor(seconds / MINUTE)} mins ago`;
      if (seconds < HOUR * 1.5) return 'An hour ago';
      if (seconds < DAY) return `${Math.floor(seconds / HOUR)} hrs ago`;
      if (seconds < DAY * 2) return 'Yesterday';
      if (seconds < WEEK) return `${Math.floor(seconds / DAY)} days ago`;
      if (seconds < WEEK * 2) return 'Last week';
      if (seconds < MONTH) return `${Math.floor(seconds / WEEK)} weeks ago`;
      if (seconds < MONTH * 2) return 'Last month';
      if (seconds < YEAR) return `${Math.floor(seconds / MONTH)} months ago`;
      if (seconds < YEAR * 2) return 'Last year';

      return `${Math.floor(seconds / YEAR)} years ago`;
    },
    toggleConfirmDialog() {
      this.showConfirmDialog = !this.showConfirmDialog;

      if (!this.showConfirmDialog) {
        this.confirmMsg = '';
        this.confirmNote = '';
        this.confirmFunction = null;
      }
    },
    toggleErrorDialog() {
      this.showErrorDialog = !this.showErrorDialog;

      if (!this.showErrorDialog) {
        this.errorMsg = '';
        this.errorTitle = '';
      }
    },
    toggleLoanLaunchMessages() {
      this.isLoanLaunchMessagesCollapsed = !this.isLoanLaunchMessagesCollapsed;
      localStorage.setItem('isLoanLaunchMessagesCollapsed', this.isLoanLaunchMessagesCollapsed);
    }
  },
  async mounted() {
    this.token = await auth.acquireTokenResponse();
    this._updateCardWidth();
    window.addEventListener('resize', this._updateCardWidth, { passive: true });

    // If this card can appear inside tabs/accordions, poke once after render
    setTimeout(this._updateCardWidth, 0);

    this.azureId = localStorage.getItem('azure_id');
    this.userName = this.token?.account?.name || localStorage.getItem('user_name') || '';
    this.userRoles = localStorage.getItem('user_roles');

    await this.GetRoles();

    this.checkGrouping(this.azureId);
    this.getLar();

    this.fetchUnreadLoanLaunchMessages();
    this.fetchLoanLaunchMessages();
    this.loanLaunchMessagesIntervalId = setInterval(this.FetchLoanLaunchMessages, 30000);
  // Initialize SignalR connection for real-time updates
      await signalRService.startConnection();

      // // Subscribe to real-time dashboard updates
      // signalRService.onBorrowerTasksUpdated((message) => {
      //   console.log('SignalR: Borrower tasks updated', message);

      //   this.fetchData('openTaskData', 'openTaskLoaded', apiService.GetSwiftDashboardData, this.azureId)
      //     .then(() => {
      //       // Clear arrays right before processing (no flash of zeros)
      //       this.borrowerTaskSum = 0;
      //       this.openTaskPending = [];
      //       this.openTaskRequested = [];
      //       this.openSigningTaskData = [];
      //       this.openTaskPendingTotal = 0;
      //       this.openTaskRequestedTotal = 0;
      //       this.openSigningTaskTotal = 0;
      //       this.processOpenTasks();
      //     });
      // });

      // signalRService.onPipelineManagementUpdated(async (message) => {
      //   console.log('SignalR: Pipeline management updated', message);
      //   // Refresh all pipeline data
      //   await this.GetExpiringLocks();
      //   await this.GetUnlockedLoans();
      //   this.fetchData('newAppsData', 'newAppsLoaded', apiService.GetSwiftDashboardNewApplications, this.azureId)
      //     .then(() => {
      //       this.newAppsData.forEach((t) => {
      //         t.logmsdatestarted = t.logmsdatestarted ? new Date(t.logmsdatestarted) : null;
      //       })
      //       this.newAppsTotal = this.newAppsData.length;
      //     });
      //   this.fetchData('disclosuresData', 'disclosuresLoaded', apiService.GetLODisclosuresCount, this.azureId)
      //     .then(() => {
      //       this.disclosuresTotal = this.disclosuresData.length;
      //     });
      //   if (this.incompleteAppSwitchChecked) {
      //     this.fetchData('incompleteAppsData', 'incompleteAppsLoaded', apiService.GetUncompletedAppsByBranchGroup, this.azureId)
      //       .then(() => {
      //         this.incompleteAppsTotal = this.incompleteAppsData.length;
      //       });
      //   } else {
      //     this.fetchData('incompleteAppsData', 'incompleteAppsLoaded', apiService.GetUncompletedAppsByLOID, this.azureId)
      //       .then(() => {
      //         this.incompleteAppsTotal = this.incompleteAppsData.length;
      //       });
      //   }
      // });

      // signalRService.onLoanTasksUpdated((message) => {
      //   console.log('SignalR: Loan tasks updated', message);

      //   // Refresh internal tasks based on switch state
      //   if (this.taskSwitchChecked) {
      //     this.fetchData('internalTasksData', 'internalTasksLoaded', apiService.GetGroupingInternalTasks, this.azureId)
      //       .then(() => {
      //         // Clear arrays right before processing (no flash of zeros)
      //         this.followUpTodayTotal = 0;
      //         this.internalTaskPending = [];
      //         this.internalTaskRequested = [];
      //         this.followUpToday = [];
      //         this.internalTaskPendingTotal = 0;
      //         this.internalTaskRequestedTotal = 0;
      //         this.pastDue = [];
      //         this.pastDueTotal = 0;
      //         this.processInternalTasks();
      //       });
      //   } else {
      //     this.fetchData('internalTasksData', 'internalTasksLoaded', apiService.GetInternalTasks, this.azureId)
      //       .then(() => {
      //         // Clear arrays right before processing (no flash of zeros)
      //         this.followUpTodayTotal = 0;
      //         this.internalTaskPending = [];
      //         this.internalTaskRequested = [];
      //         this.followUpToday = [];
      //         this.internalTaskPendingTotal = 0;
      //         this.internalTaskRequestedTotal = 0;
      //         this.pastDue = [];
      //         this.pastDueTotal = 0;
      //         this.processInternalTasks();
      //       });
      //   }
      //      // Also refresh tasks I assigned
      //   this.fetchData('tasksIAssigned', 'tasksIAssignedLoaded', apiService.GetTasksIAssigned, this.azureId)
      //     .then(() => {
      //       this.tasksIAssignedTotal = this.tasksIAssigned.length;
      //       this.tasksIAssignedChartShare = this.tasksIAssignedTotal / (this.internalTaskSum + this.tasksIAssignedTotal);
      //     });
      // });
this.fetchData(
  'openTaskData',
  'openTaskLoaded',
  apiService.GetSwiftDashboardData,
  this.azureId,
  this.taskSwitchChecked,
  this.taskSwitchChecked
).then(() => this.processOpenTasks());
    this.fetchData('newAppsData', 'newAppsLoaded', apiService.GetSwiftDashboardNewApplications, this.azureId)
      .then(() => {
        this.newAppsData.forEach((t) => {
          t.logmsdatestarted = t.logmsdatestarted ? new Date(t.logmsdatestarted) : null;
        })
        this.newAppsTotal = this.newAppsData.length;
        //For some reason this won't display if it's 0 when the page renders so it's being defaulted to 1 then decrementing here so it can display accurately
        this.pipelineManagementSum--;
        this.pipelineManagementSum += this.newAppsTotal;
      });
    this.fetchData('dailyFeedSentData', 'dailyFeedLoaded', apiService.GetDailyFeed, this.azureId)
      .then(() => this.processDailyFeed());

    await this.GetExpiringLocks();

    this.fetchData('disclosuresData', 'disclosuresLoaded', apiService.GetLODisclosuresCount, this.azureId)
      .then(() => {
        this.disclosuresTotal = this.disclosuresData.length;
        this.pipelineManagementSum += this.disclosuresTotal;
      });

    await this.GetUnlockedLoans();

    if (this.taskSwitchChecked) {
      this.fetchData('internalTasksData', 'internalTasksLoaded', apiService.GetGroupingInternalTasks, this.azureId)
        .then(() => this.processInternalTasks());
    } else {
      this.fetchData('internalTasksData', 'internalTasksLoaded', apiService.GetInternalTasks, this.azureId)
        .then(() => this.processInternalTasks());
    }

    // Load Tasks I Assigned
    this.fetchData('tasksIAssigned', 'tasksIAssignedLoaded', apiService.GetTasksIAssigned, this.azureId)
      .then(() => {
        this.tasksIAssignedTotal = this.tasksIAssigned.length;
        this.tasksIAssignedChartShare = this.tasksIAssignedTotal / (this.internalTaskSum + this.tasksIAssignedTotal);
      });

    // Load Team Tasks
    this.fetchTeamTasks();

    if (this.incompleteAppSwitchChecked) {
      this.fetchData('incompleteAppsData', 'incompleteAppsLoaded', apiService.GetUncompletedAppsByBranchGroup, this.azureId)
        .then(() => {
          this.incompleteAppsTotal = this.incompleteAppsData.length;
          this.pipelineManagementSum += this.incompleteAppsTotal;
        });
    } else {
      this.fetchData('incompleteAppsData', 'incompleteAppsLoaded', apiService.GetUncompletedAppsByLOID, this.azureId)
        .then(() => {
          this.incompleteAppsTotal = this.incompleteAppsData.length;
          this.pipelineManagementSum += this.incompleteAppsTotal;
        });
    }
    //this.fetchData('disclosuresData', 'disclosuresLoaded', apiService.GetLODisclosuresCount, '13e4e176-96d5-412f-8038-403975628113');
  },
  async created() {
    const taskSwitch = this.getCookie('taskSwitch');
    this.taskSwitchChecked = taskSwitch == 'on' ? true : false;
    const appSwitch = this.getCookie('incompleteAppSwitch');
    this.incompleteAppSwitchChecked = appSwitch == 'on' ? true : false;
    const msalAppInstance = await auth.init();

    msalAppInstance.handleRedirectPromise().then(async (tokenRes) => {

      if (!tokenRes) {
        if (!auth.user()) {
          auth.login();
        }
      }
    });
  },
  async beforeUnmount() {

    clearInterval(this.loanLaunchMessagesIntervalId)
  }
}
</script>

<style>
.iframe-container .k-content {
  padding: 0px;
  background-color: rgb(247, 247, 247);
}

.iframe-container .k-tabstrip {
  width: 100%
}

.consumer-dialog.confirm-dialog .confirm-msg {
  font-size: 2.4rem;
}

.consumer-dialog.confirm-dialog .confirm-note {
  font-weight: 600;
  margin-top: 25px;
  font-size: 2.2rem;
}

.consumer-dialog.confirm-dialog .k-window.k-dialog {
  min-width: 40%;
  min-height: 28%;
  text-align: center;
}

.consumer-dialog.confirm-dialog .dialog__btn.dialog__btn--save {
  background-color: var(--con-primary-ltr);
  font-weight: 600;
}

.consumer-dialog.confirm-dialog .confirm-msg {
  font-size: 2rem;
}

.consumer-dialog.confirm-dialog .confirm-note {
  font-weight: 600;
  margin-top: 25px;
  font-size: 1.8rem;
}

.consumer-dialog.confirm-dialog .k-window.k-dialog {
  max-width: 95%;
  min-height: 28%;
  text-align: center;
}

.consumer-dialog.confirm-dialog .k-window.k-dialog .k-dialog-title {
  font-size: 2.2rem;
}

.consumer-dialog.confirm-dialog .dialog__btn.dialog__btn--save,
.consumer-dialog.confirm-dialog .dialog__btn.dialog__btn--close {
  font-size: 1.9rem;
}

.consumer-dialog.confirm-dialog .dialog__btn.dialog__btn--save {
  background-color: var(--con-primary-ltr);
  font-weight: 600;
}

.card-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 30%;
}

.iframe-container {
  display: flex;
  flex-direction: row;
  flex-basis: 70%;
}

.card-container-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  justify-content: center;
  align-items: center;
}

.card-container-flex .dashboard-container {
  min-width: 160px;
  height: 140px;
  width: 50%;
}

  .card-container-flex .k-chart {
    height: unset;
  }

.collapse-handle {
  flex: 1;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  border-radius: 4px;
  padding: 0.25rem 0.5rem;
  background: transparent;
  color: rgb(128 128 128 / 85%);
}

.collapse-handle--inside {
  margin-left: 0.5rem;
  font-size: 1.2rem;
}

.collapse-handle--inside:hover {
  background: var(--background-dk);
}

.loanlaunch-message {
  width: 100%;
  margin-bottom: 0.5rem;
  padding: 0.5rem;
  font-size: 1.4rem;
  cursor: pointer;
  border-radius: 0.75rem;
}

.loanlaunch-message--unread {
  background: var(--background-dk);
}

.loanlaunch-message__top {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.loanlaunch-message__bottom {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.loanlaunch-message__name {
  font-weight: 600;
}

  .loanlaunch-message__date {
    font-size: 0.8em;
    color: hsla(0, 0%, 50%, .85);
    display: flex;
    align-items: center;
    gap: 0.4rem;
  }

.loanlaunch-message__content {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: .75em;
  line-height: 1.3;
  margin-top: 0.3em;
  color: var(--kendo-subtle-text);
}

  .loanlaunch-message__unread-indicator {
      font-size: 2rem;
  }

  .loanlaunch-messages-badge-wrapper {
    position: relative;
    display: inline-block;
  }

.loanlaunch-messages-badge-indicator {
  position: absolute;
  top: -0.5rem;
  right: -0.5rem;
  width: 1rem;
  height: 1rem;
  background-color: rgb(237, 118, 107);
  border-radius: 50%;
}

.card-container-vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  width: 35%;
}

.column-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 5px;
  text-align: center;
  font-size: 1.8rem;
  font-weight: 600;
  color: rgb(128 128 128 / 85%);
  border-bottom: 1px solid rgb(128 128 128 / 85%);
}

.column-header-container {
  display: flex;
  flex-direction: row;
  justify-content: start;
}

.column-header-container .k-switch-md {
  font-size: 9px;
}

.command-center-container {
  height: 100%;
  width: 100%;
  background: #f7f7f7;
  overflow: auto;
  padding: 5px;
  display: flex;
  gap: 1rem;
  flex-direction: row-reverse;
  /* Still allow scrolling if necessary */
  /* Hide scrollbar for Chrome, Safari, and Opera */
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
}

.command-center-container::-webkit-scrollbar {
  display: none;
  /* For Chrome, Safari, and Opera */
}

.command-center-container .toolbar-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.command-center-container .search-input {
  width: 15vh;
  margin-right: 10px;
}

.command-center-container .k-toolbar .k-input {
  width: unset;
}

.command-center-container .exportExcelButton {
  flex-shrink: 0;
}

.command-center-container .k-tabstrip-top>.k-tabstrip-items-wrapper .k-item {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  font-size: 2rem;
}

.dialog-container {
  height: 300px;
  width: 400px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.dialog-grid-container {
  height: 600px;
  width: 80vw;
  overflow: hidden;
}

.donut-center-text {
  font-size: 2rem;
}

.header-icon {
  font-size: 2.5rem;
}

.header-icon i {
  --fa-primary-color: #051d3a;
}

.header-text {
  display: flex;
  font-size: 1.8rem;
  align-items: center;
  padding-left: 8px;
}

.left-column {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.notification-container {
  display: flex;
  justify-content: center;
}

.pipeline-cell {
  white-space: normal;
  cursor: pointer;
}

.right-column {
  display: flex;
  flex-direction: column;
  align-items: end;
}

.single-card-container {
  width: 100%;
  height: 100%;
  min-height: 500px;
}

.single-data-point {
  font-weight: bold;
  font-size: 2.5rem;
  cursor: pointer;
}

.small-card {
  max-width: 17% !important;
}

.task-title {
  height: 30px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 1.3rem;
}

.task-total {
  font-size: 2rem;
  font-weight: 600;
}

.task-total-container {
  cursor: pointer;
  height: 100%;
  display: flex;
  /*flex: 1;*/
  justify-content: space-around;
  align-items: center;
  flex-direction: column;
  width: 100%;
}

.task-total-divider {
  display: none;
  width: 5px;
  background: black;
  height: 50px;
  border-radius: 2px;
  margin: 3px;
}

.task-totals-section {
  margin: 0 12px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}
.borrower-tasks-totals-container .column-header{
justify-content: start;
}
.totals-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: start !important;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  background: white;
  overflow:hidden;
}

.task-totals-section--grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: 16px;
  padding: 12px;
  width: 100%;
  box-sizing: border-box;
}

.task-totals-section--grid .task-total-container {
  aspect-ratio: 1 / 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.two-pane {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.two-pane-horizontal {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.two-pane-vertical {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}



.notification-container .k-dialog {
  max-height: 98%;
  width: 80%
}

.notification-container .k-dialog .html-cont {
  height: 100%;
  overflow: auto;
  /* Still allow scrolling if necessary */
  /* Hide scrollbar for Chrome, Safari, and Opera */
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
}

.notification-container .k-dialog .html-cont::-webkit-scrollbar {
  display: none;
  /* For Chrome, Safari, and Opera */
}

.notification-container>div.k-dialog-wrapper>div.k-window.k-dialog {
  max-width: 800px;
}



.conditions__notification-container .k-notification {
  padding: 0 5px;
}

.conditions__notification-container .k-notification-content {
  font-size: .9rem;
}

.newAppButton {
  margin: 5px;
  padding: 5px;
  width: 120px;
}

.button-container {
  display: flex;
  justify-content: end;
}

@media (max-width: 1024px) {
  .loanlaunch-messages {
    flex-basis: 28rem;
  }
}


@media (max-width: 925px) {


  .command-center-container {
    flex-direction: column-reverse;
  }

  .loanlaunch-messages {
    flex-basis: 50rem;
  }

  .card-container {
    flex-direction: column;
    width: 100%;
  }

  .single-card-container {
    width: 100%;
  }

  .card-container-flex .dashboard-container {
    min-width: 0;
    height: 120px;
    width: 50%;
  }

  .small-card {
    max-width: unset !important;
    min-height: 100px;
  }
}

@media (max-width: 800px) {
  .two-pane {
    flex-direction: column;
  }
}

@media (max-width: 640px) {
  .card-container {
    flex-direction: column;
  }
}



.pipeline-totals {
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
  padding: 0.25rem 0;
}

/* Keep it inline, no floating look */
.pipeline-totals-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  user-select: none;
}

/* Soft hover lift */
.pipeline-totals-row:hover {
  transform: translateY(-1px);
  transition: transform 0.15s ease;
}

/* --- Label --- */
.pipeline-totals-label {
  font-weight: 600;
  font-size: .93rem;
  color: #0f172a;
  letter-spacing: 0.1px;
}

/* --- Badge --- */
.pipeline-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.8rem;
  min-width: 1.4rem;
  height: 1.4rem;
  line-height: 1.4rem;
  border-radius: 999px;
  color: #fff;
  position: relative;
  top: -0.5px;
  /* tiny vertical offset */
  margin-right: 0.25rem;
  /* melts into text */
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);
}

/* Chart-matching colors */
.pipeline-badge--info {
  background: #a4dad7;
  color: #051d3a;
}

/* teal */
.pipeline-badge--primary {
  background: #051d3a;
}

/* navy */
.pipeline-badge--warning {
  background: #ede76b;
  color: #111827;
}

/* yellow */
.pipeline-badge--error {
  background: #ed766b;
}

/* coral */
.pipeline-badge--success {
  background: #398b87;
}

/* green */

/* Optional: micro fine-tune for visual centering */
.pipeline-badge::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;
  pointer-events: none;
}
</style>
<style>
.pm-card {
  --teal: #a4dad7;
  --navy: #051d3a;
  --yell: #ede76b;
  --coral: #ed766b;
  --green: #398b87;
  background: #fff;

}

.pm-grid {
  display: flex;
  gap: 10px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.pm-chart {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

}

.pm-chart-hole {
  position: absolute;
  font: 700 28px/1.1 ui-sans-serif, system-ui;
  color: #051d3a
}

.pm-legend {
  display: flex;
  flex-direction: column;
  gap: 10px
}

.pm-row {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  /* bounce easing */
}

.pm-row:hover {
  transform: scale(1.05);
  /* slight bounce upward */
}



.pm-badge {
  display: inline-flex;
  min-width: 22px;
  height: 22px;
  padding: 0 8px;
  border-radius: 6px;
  font: 700 12px/22px ui-sans-serif, system-ui;
  color: #fff;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .15)
}

.pm-info {
  background: var(--teal);
  color: #0b2b2b
}

.pm-primary {
  background: var(--navy)
}

.pm-warning {
  background: var(--yell);
  color: #111827
}

.pm-error {
  background: var(--coral)
}

.pm-success {
  background: var(--green)
}

.pm-label {

  color: #0f172a;
  letter-spacing: .1px
}



.pm-label {
  white-space: nowrap;
  /* Prevent wrapping */
  overflow: hidden;
  /* Hide overflow if it still exceeds width */
  text-overflow: ellipsis;
  /* Show "..." if text is clipped */
  display: inline-block;
  vertical-align: middle;


  font-weight: 300;
  color: #0f172a;
  letter-spacing: 0.1px;
}

.pm-card {
  container-type: inline-size;
  container-name: pmcard;
  --pm-scale: 1;
  display: flex;
  gap: 12px;

  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  padding: 10px;
  background: #fff;

  box-sizing: border-box;
  width: 100%;
  height: 100%;
}

.pm-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  /* Sizing */
  width: 3rem;
  /* plenty of space for 3 digits */
  height: 2.1rem;
  /* taller for visual balance */
  border-radius: 9px;
  /* slightly softer corners for the new height */

  /* Typography */
  font-weight: 700;
  font-size: 1.15rem;
  /* 🔹 nice large, dashboard-readable font */
  line-height: 1;
  letter-spacing: 0.25px;
  color: #fff;

  /* Aesthetic polish */
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
  text-shadow: 0 1px 0 rgba(0, 0, 0, 0.25);
  user-select: none;
  flex-shrink: 0;
}

@media (min-width: 925px) {
  .pm-label {
    /* Responsive font sizing with clamp(min, preferred, max) */
    font-size: clamp(0.83rem, 1.6vw, 1.13rem);
  }
}

.pm-card {
  display: flex;
  gap: 12px;
  padding: 5px;
  box-sizing: border-box;
  width: 100%;
}

.pm-legend {
  flex: 0 0 145px;
}

/* reserve legend width */
.pm-chart {
  flex: 1 1 0;
  min-width: 0;
}

/* allow the chart area to actually shrink */

/* General badge base */
.pm-badge {
  font-weight: 700;
  color: #0f172a;
  /* darker text by default for readability */
}

/* Softer palette (lighter backgrounds, higher contrast text) */
.pm-badge.pm-info {
  background: #c8efec;
  color: #063a39;
}

/* teal */
.pm-badge.pm-primary {
  background: #d4e0f7;
  color: #132a5e;
}

/* navy */
.pm-badge.pm-warning {
  background: #fbf8d0;
  color: #4b4700;
}

/* yellow */
.pm-badge.pm-error {
  background: #f8c8c2;
  color: #6d0c05;
}

/* coral */
.pm-badge.pm-success {
  background: #c4e8e4;
  color: #064f47;
}

/* green */
.pm-badge.pm-critical {
  background: #f5bdb8;
  color: #5b0c08;
}

/* past due – softened red */
.pm-badge.pm-purple {
  background: #e3d8f0;
  color: #3e2d63;
}

/* team tasks – teal */
.pm-badge.pm-teal {
  background: #b2dfdb;
  color: #004d40;
}

/* Team badge for assigned to column */
.team-badge {
  display: inline-flex;
  align-items: center;
  background-color: #e3f2fd;
  padding: 2px 8px;
  border-radius: 4px;
  color: #1565c0;
  font-size: 0.9em;
  gap: 5px;
}

/* tasks I assigned – softer purple */
.pm-badge {
  box-shadow: inset 0 1px 2px rgba(255, 255, 255, 0.2),
    0 1px 2px rgba(0, 0, 0, 0.08);
}

/* Internal Task Actions Cell Styles */
.actions-cell {
  padding: 8px !important;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
}

.action-btn {
  min-width: 80px;
  font-size: 1.2rem;
  padding: 6px 12px;
  transition: all 0.2s ease;
}

.action-btn.complete-btn {
  background-color: #051d3a;
  border-color: #051d3a;
}

.action-btn.complete-btn:hover {
  background-color: #03152b;
  border-color: #03152b;
  transform: translateY(-1px);
}

.completed-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #398b87;
  font-weight: 600;
  font-size: 1.3rem;
}

.completed-badge i {
  font-size: 1.5rem;
}
</style>
